import svgPanZoom from "svg-pan-zoom";

/**
 * Handles the zoom on the documents through its SVG tag.
 */
export class ZoomManager {
    svgSuffix: string = "";
    zoom = 1.0;
    /**
     * Rotation angle in degrees
     */
    rotation = 0;
    SvgOptions = {
        contain: false,
        controlIconsEnabled: false,
        zoomEnabled: true,
        dblClickZoomEnabled: false,
        mouseWheelZoomEnabled: false,
        preventMouseEventsDefault: true,
        panEnabled: true,
        maxZoom: 5,
        minZoom: 0.01,
        customEventsHandler: {
            haltEventListeners: [
                "touchStart",
                "touchEnd",
                "touchMove",
                "touchLeave",
                "touchcancel",
            ],
            init: () => {},
            destroy: () => {},
        },
    };

    instance: SvgPanZoom.Instance = null;
    listenerAdded: boolean = false;

    getImageElement() {
        return document.getElementById("svg-image-" + this.svgSuffix);
    }

    getSvgElement() {
        return document.getElementById("svg-" + this.svgSuffix);
    }

    /**
     * Rotates the SVG element by a specified angle
     *
     * @param angle - The angle in degrees to rotate the SVG element
     *
     * applies the new rotation to the SVG element using the `transform` attribute
     */
    rotateSvg(angle: number) {
        const svg = document.getElementById("svg-" + this.svgSuffix);
        console.log(angle);
        if (svg) {
            this.rotation += angle;
            svg.setAttribute("transform", `rotate(${this.rotation} 50 50)`);
        }
    }

    disableZoomOut() {
        return this.zoom <= -5;
    }

    disableZoomIn() {
        return this.zoom >= 5;
    }

    disableResetZoom() {
        return false;
    }

    zoomOut() {
        const elem = this.getSvgElement();
        if (elem) {
            const parentPos: DOMRect = elem.getBoundingClientRect();
            this.animateZoom(elem, 200, 30, -1, parentPos);
        }
    }

    zoomIn() {
        const elem = this.getSvgElement();
        if (elem) {
            const parentPos: DOMRect = elem.getBoundingClientRect();
            this.animateZoom(elem, 200, 30, 1, parentPos);
        }
    }

    resetZoom() {
        this.zoom = 1;
        if (this.instance) {
            this.instance.resetZoom();
            this.instance.center();
        }
    }

    instanciateSvgZoom(suffix) {
        this.svgSuffix = suffix;

        if (!this.svgSuffix) {
            return;
        }

        const intervalID = setInterval(() => {
            const svg = this.getImageElement();
            if (svg) {
                clearInterval(intervalID);
                if (!this.listenerAdded) {
                    this.listenerAdded = true;
                    this.action(svg);
                } else {
                    this.action(svg);
                }
            }
        }, 100);
    }

    action(svg) {
        const height = svg.getBoundingClientRect().height;
        const elem = this.getSvgElement();
        if (elem) {
            elem.style.height = `${height}px`;
            this.instance = svgPanZoom("#svg-" + this.svgSuffix, this.SvgOptions);
        } else {
            debugger; // git-ignore
        }
    }

    animateZoom(
        img: HTMLElement,
        duration: number,
        stepTime: number,
        scalarZoom: number,
        coord: DOMRect,
    ) {
        if (this.instance) {
            const animationSteps = duration / stepTime;
            let zoomStep = 0;
            if (this.zoom > 1) {
                zoomStep = 1 + scalarZoom / stepTime;
            } else if (this.zoom < 1) {
                zoomStep = 1 + scalarZoom / (stepTime * 5);
            } else if (scalarZoom > 0) {
                zoomStep = 1 + scalarZoom / stepTime;
            } else {
                zoomStep = 1 + scalarZoom / (stepTime * 5);
            }
            const elem = img;
            if (elem) {
                const parentPos: DOMRect = elem.getBoundingClientRect();

                let animationStep = 0;
                const intervalID = setInterval(() => {
                    if (animationStep < animationSteps) {
                        this.instance.zoomAtPointBy(zoomStep, {
                            x: coord.x - parentPos.x + parentPos.width * 0.5,
                            y: coord.y + window.scrollY,
                        });

                        this.instance.resize();
                        animationStep += 1;
                    } else {
                        clearInterval(intervalID);
                        this.zoom += scalarZoom;
                    }
                }, stepTime);
            }
        }
    }
}
